<template>
  <div>
    <div v-if="showClose" class="comp-close">
      <v-btn small text icon @click="close()" :disabled="!$auth.manage || isHistory">
        <icon-svg iconName="comp-close" />
      </v-btn>
    </div>
    <v-card class="proc-component">
      <v-card-title class="proc justify-center darken-1" @dblclick="openRightLayer()">
        <icon-svg :size="procIconSize" iconName="proc-group" />
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import $ from 'jquery';
import IconSvg from '@/vue-caas/components/IconBase.vue';

export default {
  components: {
    IconSvg,
  },
  props: {
    comId: {
      default: '',
    },
    isHistory: {
      default: false,
    },
    comTp: {
      default: 'GRP',
    },
    setDisable: {
      default: false,
    },
    manage: {
      default: false,
    },
  },
  data() {
    return {
      procIconSize: 24,
      showClose: false,
      formData: {
        id: '',
        procNm: '',
      },
      hideItem: true,
      hideText: 'Expand',
      usrItem: [],
      nodeId: '',
      arrProcGrp: [],
      formEmit: {
        comTp: 'GRP',
        comId: '',
        nodeId: '',
      },
    };
  },
  computed: {
    ...mapState('map', {
      mapList: 'mapListSMLK',
    }),
    workflowGroupList() {
      return this.$store.getters.workflowGroupSelectBoxList;
    },
  },
  watch: {
    comId() {
      return this.comId;
    },
  },
  mounted() {},
  methods: {
    resetForm() {
      this.formData = {
        id: '',
        procNm: '',
      };
      this.formEmit = {
        comId: '',
        nodeId: this.nodeId,
        comName: '',
        comTp: this.comTp,
      };
      EventBus.$emit('set-comp-id', this.formEmit);
    },
    changeComponentData(id, nodeId) {
      if (nodeId === this.nodeId) {
        this.formData.id = id;
        if (!this.formData.id) {
          this.resetForm();
          return;
        }
        this.selectWorkflowGroup();
      }
    },
    openRightLayer() {
      if (this.manage || this.isHistory) {
        EventBus.$emit('open-right-layer', this.formEmit);
      }
    },
    selectWorkflowGroup() {
      const id = this.formData.id;
      let index = this.workflowGroupList.findIndex((e) => e.id == id);
      if (index > -1 && (this.manage || this.isHistory)) {
        this.formData = Object.assign({}, this.workflowGroupList[index]);
        this.formEmit = {
          comId: this.formData.id,
          nodeId: this.nodeId,
          comName: this.formData.procNm,
          comTp: this.comTp,
        };
        EventBus.$emit('set-comp-id', this.formEmit);
        const params = {
          procId: this.formData.id,
          hash: this.$cookies.get('hash'),
        };
        this.$store.dispatch('getWorkflowGroupDtlList', params).then(() => {
          this.arrProcGrp.forEach((e) => {
            if (e.comTp === 'MAP') {
              EventBus.$emit('close', '', e.comId);
            }
          });
          this.arrProcGrp = this.$store.getters.workflowGroupDtlList;
          this.arrProcGrp.forEach((e) => {
            if (e.comTp === 'MAP') {
              const index = this.mapList.findIndex((item) => item.MAP_PRCS_NO === e.comId);
              if (index > -1) {
                e.comInfo = this.mapList[index];
              }
              let objSrm = {
                id: '1',
                sender: '',
                recipient: '',
                isUseDifferentEDI: 0,
              };
              let infoEmitMap = {
                mapperId: e.comId,
                info: [objSrm],
              };
              EventBus.$emit('set-map-contract', infoEmitMap);
            }
          });
        });
      } else {
        this.resetForm();
      }
    },
    openWorkflowGroupView() {
      EventBus.$emit('open-workflow-group-component', this.formData);
    },
    close() {
      this.arrProcGrp.forEach((e) => {
        if (e.comTp === 'MAP') {
          EventBus.$emit('close', '', e.comId);
        }
      });
      EventBus.$emit('close', this.nodeId);
    },
    async initialize() {
      this.$nextTick(() => {
        this.nodeId = this.$el.parentElement.parentElement.id;
        this.formData.id = this.comId;

        if (this.formData.id !== '') {
          this.selectWorkflowGroup();
        } else {
          this.formEmit = {
            comId: '',
            nodeId: this.nodeId,
            comName: '',
            comTp: this.comTp,
          };
          EventBus.$emit('set-comp-id', this.formEmit);
        }
      });
    },
  },
  created() {
    this.initialize();
    EventBus.$on('change-component-data', this.changeComponentData);
  },
};
</script>
